import { ThemeType } from '@uipath/portal-shell-util';

export enum ThemeEvent {
    SetCachedThemeAsSelectedThemeOnInit = 'ThemeEvent.SetCachedThemeAsSelectedThemeOnInit',
    SetUserThemeAsCachedThemeOnInit = 'ThemeEvent.SetUserThemeAsCachedThemeOnInit',
    ProfileMenuThemeClicked = 'ThemeEvent.ProfileMenuThemeClicked',
}

type SetCachedThemeAsSelectedThemeOnInitPayload = {
    isSettingUserTheme: boolean;
    cachedTheme: ThemeType;
};

type SetUserThemeAsCachedThemeOnInitPayload = {
    userTheme: ThemeType;
};

type ProfileMenuThemeClickedPayload = {
    theme: ThemeType;
};

export interface ThemeEventMap {
    [ThemeEvent.SetCachedThemeAsSelectedThemeOnInit]: SetCachedThemeAsSelectedThemeOnInitPayload;
    [ThemeEvent.SetUserThemeAsCachedThemeOnInit]: SetUserThemeAsCachedThemeOnInitPayload;
    [ThemeEvent.ProfileMenuThemeClicked]: ProfileMenuThemeClickedPayload;
}
